<template>
	<div class="page-main" ref="scrollDom">
		<div class="app-head">
			<nav-bar :left-arrow="true" title="支付" @click-left="back" />
		</div>

		<div class="pay-bg"></div>

		<div class="pay-content">

			<vue-qr :text="'http://140.143.213.135/tradePay?orderid='+info.orderId" :size="250"
				v-clipboard:error="onError" v-clipboard:copy="'http://140.143.213.135/tradePay?orderid='+info.orderId"
				v-clipboard:success="onCopy"></vue-qr>
			<p>请用支付宝扫描二维码,完成支付</p>
			<vue-qr :text="info.biz_content" :size="250" v-clipboard:error="onError" v-clipboard:copy="info.biz_content"
				v-clipboard:success="onCopy"></vue-qr>
			<p>请用支付宝调试器扫描二维码,完成支付</p>

			<a @click="goPay" class="pay-btn">网页付款</a>
			<a @click="goPage" class="pay-btn">支付宝付款(PC,微信不支持)</a>



			<router-link replace :to="{ name: 'historytwo' }" style="color: #666">返回订单</router-link>
		</div>
	</div>
</template>


<script>
	import {
		NavBar
	} from "vant";
	import vueQr from "vue-qr";
	import BScroll from "@better-scroll/core";




	export default {
		components: {
			NavBar,
			vueQr,
		},
		data() {
			return {
				info: null,
			};
		},
		created() {
			var data = this.$route.query.data;
			this.info = JSON.parse(data);
			this.$nextTick(() => {
				this.isloading = false;
				this.leftScroll = BScroll(this.$refs["scrollDom"], {
					click: true,
				});
			});

			window.onShow = function() {
				alert(123)
			}
		},
		methods: {
			onCopy() {
				this.$msg("链接已复制");
			},
			onError() {
				this.$msg("您的设备暂不支付复制");
			},
			back() {
				this.$route.back();



			},
			goPay() {
				//console.log("https://openapi.alipay.com/gateway.do?"+this.info.biz_content);
				//console.log(this.info.alipay);



				location.href = this.info.alipay;

			},
			goPage() {
				location.href =
					"alipays://platformapi/startapp?appId=20000067&url=" +
					encodeURIComponent("http://140.143.213.135/tradePay?orderid=" + this.info.orderId);
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep .van-nav-bar .van-icon {
		color: #333 !important;
	}


	.page-main {
		position: relative;
		height: 100vh;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background: #f1f1f1;
	}

	.pay-bg {
		height: 200px;
		background: #fff;
		overflow: hidden;
		position: relative;

		&::after {
			width: 100%;
			height: 100px;
			border-radius: 50%;
			content: "";
			background: #f1f1f1;
			display: inline-block;
			transform: scale(1.2) translateY(100px);
		}
	}

	.pay-content {
		text-align: center;

		.icon {
			width: 180px;
			height: 180px;
			display: block;
			margin: auto;
			margin-top: -160px;
			margin-bottom: 80px;
			position: relative;
			z-index: 10;
		}

		.pay-btn {
			background: #07c160;
			display: block;
			width: 300px;
			height: 60px;
			line-height: 60px;
			margin: auto;
			color: #fff;
			border-radius: 8px;
			margin-bottom: 20px;
		}
	}
</style>
